<template>
    <div :class="itemClass">
        <a :href="'/knowledge-base/' + post.id" class="img-box" @click.prevent="handleClick(post.id)" @mouseover="onHover=true" @mouseleave="onHover=false">
            <img :src="post.image" alt=""/>
        </a>
        <div class="text">
            <post-date :post="post"></post-date>
            <p class="title">
                <a :href="'/knowledge-base/' + post.id" @click.prevent="handleClick(post.id)" @mouseover="onHover=true" @mouseleave="onHover=false">{{post.title}}</a>
            </p>
            <tag-list :tags="getPostTags(post.tags)" :active-tags="activeTags" @click="getPostsAfterTagClick($event)"></tag-list>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex'
    import TagList from "../common/TagList";
    import PostDate from "./PostDate";

    export default {
        name: 'post-component',
        components: {PostDate, TagList},
        props: ['post'],
        data() {
            return {
                onHover: false,
            }
        },
        computed: {
            ...mapState({
                tags: state => state.knowledge.tags,
                activeTags: state => state.knowledge.activeTags,
                active: state => state.knowledge.activePost,
            }),
            ...mapGetters('knowledge', [
                'getPostTags',
            ]),
            itemClass () {
                let css = this.onHover ? "on-hover item js-interlinked-item" : "item js-interlinked-item";
                css += this.post.id === this.active.id ? ' active': '';
               return css
            },
        },
        methods: {
            ...mapActions('knowledge', [
                'getPost',
                'getPostsAfterTagClick'
            ]),
            hoverItem() {
                this.onHover = !this.onHover
            },
            handleClick(id) {
                //this.getPost({id: id});
                this.$store.commit('setNavVisible',false);
                this.$router.push({path: '/knowledge-base/' + id, query: this.$route.query}).catch(() => {
                    //console.log(err);
                })
            }
        },
    }
</script>

<style scoped>

</style>
